<template>
    <div class="container">
        <v-card class="py-3 px-5">
            <v-form ref="form" v-model="valid">
                <v-text-field
                    v-model="listName"
                    disabled
                    label="List Name"
                    required>
                </v-text-field>

                <v-text-field
                    v-model="list.text"
                    label="Text"
                    :rules="[value => !!value || 'Required.']"
                    required>
                </v-text-field>

                <v-text-field
                    v-model="list.description"
                    label="Description (optional)">
                </v-text-field>

                <v-text-field
                    v-model="list.value"
                    label="Value (optional)"
                    persistent-hint
                    hint="If left blank, we can make a value from the text.">
                </v-text-field>

                <!-- <v-text-field
                    v-model="list.hubspot_internal"
                    label="Hubspot"
                    :rules="[value => !!value || 'Required.']"
                    required>
                </v-text-field>  -->

                <v-text-field
                    v-if="!listIsAlpha"
                    v-model="list.sort_order"
                    label="Sort Order">
                </v-text-field>

                <v-switch
                    v-model="isActive">
                    <template v-slot:label>Active</template>
                </v-switch>

                <v-btn 
                    v-if="!newList"
                    color="info" 
                    class="my-3 d-block"
                    @click="updateList">
                    Update List
                </v-btn>
                
                <v-btn
                    v-if="newList"
                    color="info" 
                    class="my-3 d-block"
                    @click="createList">
                    Create List Item
                </v-btn>
            </v-form>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios';
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';

    export default {

      data: () => ({
          listToUpdateId: null,
          allListData: [],
          allItems: [],
          list: {},
          newList: false,
          listName: null,
          listIsAlpha: true,
          isActive: true,
          valid: null
      }),

        created () {
            if (this.$route.params.lid) {
              this.listToUpdateId = this.$route.params.lid
              this.getList();
            }
            if (this.$route.params.listName) {
              this.getList();
              this.newList = true;
              this.listName = this.$route.params.listName;
              this.isListAlpha();
            }
          },
    
        methods: {
            getList: async function () {
                try {
                    const all_lists_rs = await axios.post(`${appUrls.api}/api/admin/formfieldlists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    if(all_lists_rs.data.outcome){
                        let arrLists = all_lists_rs.data.lists;   
                        for (let l in arrLists) {
                        this.allListData[l] = arrLists[l]
                        }
                        if (this.listToUpdateId) {
                        this.list = arrLists.find((list) => {
                            return list.id == this.listToUpdateId;
                        });
                        this.listName = this.list.list_name;
                        this.listIsAlpha = this.list.is_alpha;
                        }
                        this.allListData.forEach(item => {
                        if (item.list_name === this.listName) {
                            this.allItems.push(item)
                        }
                        })
                    }
                } catch ( error ) {
                    console.log(error);
                };
            },

            isListAlpha: async function () {
                try {
                    const all_lists_rs = await axios.post(`${appUrls.api}/api/admin/formfieldlists`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                    if(all_lists_rs.data.outcome){
                        let arrLists = all_lists_rs.data.lists;
                        let firstList = arrLists.find(list => list.list_name == this.$route.params.listName);
                        this.listIsAlpha = firstList.is_alpha
                    }
                } catch ( error ) {
                    console.log(error);
                };
            },

            updateList: async function () {
                this.$refs.form.validate();
                if (this.valid) {
                if (this.listIsAlpha) {
                    this.list.sort_order = 0
                }
                    try {
                        await axios.put(`${appUrls.api}/api/admin/updateformfieldlist`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data:
                                { 
                                id: this.list.id,
                                list_name: this.list.list_name,
                                text: this.list.text,
                                value: this.list.value,
                                // hubspot_internal: this.list.hubspot_internal,
                                description: this.list.description,
                                sort_order: this.list.sort_order,
                                is_active: this.list.is_active,
                                is_alpha: this.listIsAlpha
                                }
                        })
                        this.$router.push({ path: `/datamanagement/${this.listName}`});
                    } catch(error) {
                        console.error(error);
                    }
                }
            },

            createList: async function() {
                this.$refs.form.validate();
                if (this.valid) {
                    if (this.listIsAlpha) {
                        this.list.sort_order = 0
                    }

                    const form_value = this.list.value == null ? this.list.text : this.list.value
                    const trimmed_value = form_value.trim()
                    const converted_value = trimmed_value.replaceAll('(', '').replaceAll(')', '').replaceAll(',', '').replaceAll('.', '').replaceAll('/', ' ').replaceAll("'", '').replaceAll('&', ' ').replaceAll('_', '-').replaceAll(' ', '-').toLowerCase()

                    try {
                        await axios.post(`${appUrls.api}/api/admin/createformfieldlist`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            data:
                                {
                                    list_name: this.listName,
                                    text: this.list.text,
                                    value: converted_value,
                                //   hubspot_internal: this.list.hubspot_internal,
                                    description: this.list.description,
                                    sort_order: this.list.sort_order,
                                    is_active: this.isActive,
                                    is_alpha: this.listIsAlpha
                                }
                            })
                        this.$router.push({ path: `/datamanagement/${this.listName}`});
                    } catch(error) {
                        console.log(error);
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/FormFieldDetails.vue